import React from 'react';
import classnames from 'classnames';
import Product from './product/product';
import productsStyles from './products.module.pcss';
import { ListerProductData } from '../../../../types';
import FavouritesBanner from '../favouritesBanner/favouritesBanner';
import useFavouritesHandler from './hooks/useFavouritesHandler';
import useRowProps from './hooks/useRowProps';
import initGlobalUtils from '../../../../utils/globalUtils';

interface ProductsProps {
  products: ListerProductData[];
  isBiggerImagesSelected: boolean;
  rid: string;
}

function Products({ products, isBiggerImagesSelected, rid }: ProductsProps): React.ReactElement {
  const { addedToFavourites, setAddedToFavourites, favouritesData, favouritesToggler } = useFavouritesHandler();
  const rowPropsMap = useRowProps(products, isBiggerImagesSelected);
  const favouritesCopy = [...favouritesData.entries];

  React.useEffect(() => {
    initGlobalUtils('load', products);
  }, []);

  return (
    <div
      id="products"
      className={classnames(productsStyles.products, {
        [productsStyles['products--bigger-images']]: isBiggerImagesSelected
      })}
    >
      {products.map((p, index) => {
        // This is to identify the products that are favourite
        let isFavourite = false;
        for (let j = 0; j < favouritesCopy.length; j += 1) {
          if (p.code === favouritesCopy[j].productCode) {
            favouritesCopy.splice(j, 1);
            isFavourite = true;
          }
        }

        // This is to pass props that define the height of the product card (what placeholders to show)
        const { row } = rowPropsMap[index] || 0;
        const { hasColorSwatches, hasIfcMessage } = rowPropsMap[index]?.rowProps[row] || [];

        return (
          <Product
            showColorSwatchPlaceholder={hasColorSwatches}
            showIfcMessagePlaceholder={hasIfcMessage}
            handleFavouritesClick={favouritesToggler}
            key={p.code}
            index={index}
            product={p}
            rid={rid}
            isFavourite={isFavourite}
          />
        );
      })}
      <FavouritesBanner setAddedToFavourites={setAddedToFavourites} product={addedToFavourites} />
    </div>
  );
}

export default Products;
